import { createSlice } from '@reduxjs/toolkit';
import { API } from 'aws-amplify';
import { LocalCache } from '../libreria/LocalCache';

export const notascobroSlice = createSlice({
  name: 'notascobro',
  initialState: {
    page: -1,
    count: 0,
    rows: []
  },
  reducers: {
    setNotasCobro: (state, action) => {
      state.page = action.payload.page;
      state.count = action.payload.count;
      state.rows = action.payload.rows;
    }
  }
});

export const { setNotasCobro } = notascobroSlice.actions;

// Action Creators
export const getNotasCobro = (comunidadId, anno, mes, page, size) => async (dispatch, getState) => {
  let offset = page * size;
  let item = LocalCache.get(`KEY:notascobro&comunidad=${comunidadId}&ano=${anno}&mes=${mes}&offset=${offset}`);
  if (item) {
    dispatch(setNotasCobro(item));
  } else {
    try {
      const response = await API.get('ePlat', `/notascobro?comunidad=${comunidadId}&ano=${anno}&mes=${mes}&offset=${offset}&size=${size}`);
      let notascobro = { page: response.count > 0 ? page : -1, count: response.count, rows: response.rows };
      dispatch(setNotasCobro(notascobro));
      LocalCache.put(`KEY:notascobro&comunidad=${comunidadId}&ano=${anno}&mes=${mes}&offset=${offset}`, notascobro);
    } catch (error) {
      console.log('DVD: ERROR Llamada a getNotasCobro()', error);
    }
  }
};

export default notascobroSlice.reducer;
